import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { theSportshipContent } from '../rich-content/the-sportship-complete-content';

const TheSportshipDetailPage = () => {
  return <AutomaticPageBuilder content={theSportshipContent} />;
};

export default TheSportshipDetailPage;
